import styled from 'styled-components';
import USER_OWN_TRACTOR_IMAGE_MAIN from '../../../../../assets/images/userOwnTractor/user_own_tractor_image_main.png';
import { Chip } from '../../../../../components/common/chip/Chip';

export const OwnTractorSurveyMainSection = () => {
  return (
    <Container>
      <TextContainer>
        <Title>{'내 트랙터를 등록하고\n다양한 가격 제안 받기'}</Title>
        <Description>{'정보를 자세히 입력할수록\n더 많은 제안이 들어와요.'}</Description>
      </TextContainer>
      <Image imageUrl={USER_OWN_TRACTOR_IMAGE_MAIN} />
      <FeatureDescriptionSectionContainer>
        <ChipContainer>
          <Chip
            type={'round'}
            theme={'strong'}
            color={'white'}
            size={'lg'}
            icon={{ name: 'Check', position: 'left', size: 'Large', fill: '#34C77E' }}
          >
            {'가볍게 시세확인'}
          </Chip>
          <Chip
            type={'round'}
            theme={'strong'}
            color={'white'}
            size={'lg'}
            icon={{ name: 'Check', position: 'left', size: 'Large', fill: '#34C77E' }}
          >
            {'트랙터 무료 홍보'}
          </Chip>
        </ChipContainer>
      </FeatureDescriptionSectionContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const Title = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const Image = styled.div<{ imageUrl: string }>`
  height: 174.545px;
  align-self: stretch;
  aspect-ratio: 320/174.55;
  background: ${(props) => `url(${props.imageUrl}) transparent 50% / cover no-repeat;`};
`;

const FeatureDescriptionSectionContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--radius-large, 16px);
`;

const ChipContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--radius-small, 4px);
`;
